<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Can the money be paid into a bank account that is not in my name, for example a partner’s?<Caret /></summary>
  <p>
    No. We require the money to be paid directly to you and you will need to enter your bank details.
  </p>
</details>
